const progressStepperHelper = (currentStep) => {
    const stepsList =
        [
            { content: 'Verify identity' },
            { content: 'Personal details' },
            { content: 'Card eligibility' },
            { content: 'Marketing preferences' },
            { content: 'Review' }
        ];

    stepsList.forEach((step, i) => {
        step.status = i < currentStep ? 'completed' : (i === currentStep ? 'current' : 'todo');
    })
    return stepsList;
};

const formHeaderLabel = 'Apply for a NSW Seniors Card or NSW Senior Savers Card';

const formHeaderTitles = [
    'Verify identity',
    'Personal details',
    'Card eligibility',
    'Marketing preferences',
    'Review and submit'
];

export {
    progressStepperHelper,
    formHeaderLabel,
    formHeaderTitles
};
